import React from 'react';
import styles from '../../../styles/ListingManagement.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';
import type { ListingClientDocumentType } from '../../../types/ListingTypes';

interface Props {
  clientName: string;
  onClose: () => void;
  documentTypes: ListingClientDocumentType[];
  docTypeId: string;
  onDocTypeChange: (id: string) => void;
  name: string;
  onNameChange: (name: string) => void;
  file: File | null;
  onFileChange: (file: File | null) => void;
  uploading: boolean;
  error: string | null;
  onUpload: () => void;
}

const AddClientDocumentModal: React.FC<Props> = ({
  clientName, onClose, documentTypes, docTypeId, onDocTypeChange, name, onNameChange,
  file, onFileChange, uploading, error, onUpload,
}) => (
  <div
    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
    onClick={onClose}
  >
    <div
      style={{ background: '#fff', borderRadius: 10, padding: 28, width: 460, maxWidth: '92vw', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}
      onClick={e => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}>Add Document</h4>
          <p style={{ margin: '4px 0 0', fontSize: '0.85em', color: '#6c757d' }}>{clientName}</p>
        </div>
        <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', lineHeight: 1, cursor: 'pointer', color: '#6c757d' }}>×</button>
      </div>

      {error && <p className={styles.agreementFormError}>{error}</p>}

      <div className={styles.categoryRow}>
        <label className={styles.categoryLabel}>Document Type</label>
        <div className={styles.categoryInputWrapper} style={{ width: 'fit-content' }}>
          <select
            className={styles.categoryInput}
            value={docTypeId}
            onChange={e => onDocTypeChange(e.target.value)}
          >
            <option value="">— Select type —</option>
            {documentTypes.map(dt => <option key={dt.id} value={dt.id}>{dt.name}</option>)}
          </select>
        </div>
      </div>

      <div className={styles.categoryRow}>
        <label className={styles.categoryLabel}>Name</label>
        <div className={styles.categoryInputWrapper}>
          <input
            type="text"
            placeholder="Document name"
            className={styles.categoryInput}
            value={name}
            onChange={e => onNameChange(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.categoryRow}>
        <label className={styles.categoryLabel}>File</label>
        <div className={styles.categoryInputWrapper} style={{ overflow: 'hidden' }}>
          <input
            type="file"
            className={styles.categoryInput}
            style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
            onChange={e => onFileChange(e.target.files?.[0] ?? null)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 }}>
        <button type="button" className={`${buttonStyles.button} ${buttonStyles.secondary}`} onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className={`${buttonStyles.button} ${buttonStyles.primary}`}
          disabled={!file || !docTypeId || !name.trim() || uploading}
          onClick={onUpload}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </div>
    </div>
  </div>
);

export default AddClientDocumentModal;
